export const ACTION = {
    OPEN_MODAL : 'OPEN_MODAL',
    CLOSE_MODAL : 'CLOSE_MODAL',
    HIDE_MODAL_HEADER : 'HIDE_MODAL_HEADER',
    SEND_OTP : 'SEND_OTP',
    GET_ACCOUNT_STATEMENT:"GET_ACCOUNT_STATEMENT",
    POST_REMUNERATION:"POST_REMUNERATION",
    CLEAR_REMUNERATION:"CLEAR_REMUNERATION",
    GET_REMUNERATION_YEARS:"GET_REMUNERATION_YEARS",
    VERIFY_OTP: 'VERIFY_OTP',
    CLEAR_VERIFY_OTP: 'CLEAR_VERIFY_OTP',
    CLEAR_SEND_OTP: 'CLEAR_SEND_OTP',
    POST_INVEST_ETF: 'POST_INVEST_ETF',
};

export const MODALS = {
    SUBCRIBE_PRODUCTS:'SUBCRIBE_PRODUCTS',
    TRUSTEE_DETAIL:'TRUSTEE_DETAIL',
    INVEST_OPTIONS:'INVEST_OPTIONS',
    ACCOUNT_STATEMENT : 'ACCOUNT_STATEMENT',
    REMUNERATION_LOGIN : 'REMUNERATION_LOGIN',
    CONTINUED_INVESTOR:"CONTINUED_INVESTOR",
    BASIC_FORM: 'BASIC_FORM',
    BASIC_FORM_ETF: 'BASIC_FORM_ETF',
    VERIFY_OTP: 'VERIFY_OTP',
    FORCE_LOGOUT: 'FORCE_LOGOUT',
    ERROR_MODAL: 'ERROR_MODAL',
    SUCCESSS_MODAL: 'SUCCESSS_MODAL',
    // ecart start
    ECART_MODAL: 'ECART_MODAL',
    AUTHENTICATION: 'AUTHENTICATION',
    VERIFY_OTP_ECART:'VERIFY_OTP_ECART',
    REPLACE_ITEMS_ECART:'REPLACE_ITEMS_ECART',
    ERROR_MODAL_ECART: 'ERROR_MODAL_ECART',
    EKYC_VALIDATE_MODAL: 'EKYC_VALIDATE_MODAL'
    // ecart end
};

